export interface Contact {
  name: string;
  location: string;
  email: string;
  linkedin: string;
}

export interface Experience {
  company: string;
  title: string;
  period: string;
  bullets: string[];
}

export interface Education {
  year: string;
  degree: string;
  institution: string;
}

export interface Resume {
  contact: Contact;
  summary: string;
  experience: Experience[];
  education: Education[];
  skills: string[];
}

const d = (s: string) => atob(s);

export const resume: Resume = {
  contact: {
    name: "Corey Pyle",
    location: "Clayton, GA | Remote",
    email: d("Y29yZXlweWxlQGdtYWlsLmNvbQ=="),
    linkedin: "https://www.linkedin.com/in/coreypyle/",
  },

  summary:
    "Software engineer with over 10 years of successful product and feature delivery. Senior technologist with a passion for creating experiences that are impactful for the customer, financially fruitful for the company, and delightful for the engineer.",

  experience: [
    {
      company: "Amazon Web Services",
      title: "Software Development Engineer II",
      period: "Aug 2022 – Present",
      bullets: [
        "Developed an AI-assisted content processing tool using Amazon Bedrock and the open-source Ailly framework that automated the generation of grammatically specific summaries for thousands of structured content pieces, significantly reducing manual effort for content writing teams.",
        "Helped to streamline code examples based on user research findings by implementing more concise, deployment-free examples. Customers benefited from more consistency, higher standards, and better documentation.",
        "Redefined team processes to reduce the amount of time spent in meetings, and increase the value of any time spent.",
        "Reduced DLQ messages from ~300k to ~50 by optimizing a queue handler via SQS batch response, visibility timeout jitter, more exhaustive error handling, and improved filtering against the event source.",
      ],
    },
    {
      company: "Mobiquity Inc.",
      title: "Senior Front-End Engineer",
      period: "June 2016 – Aug 2022",
      bullets: [
        "Led 3-year development of the high-profile AWS Events mobile application used during re:Invent, serving as lead developer responsible for feature delivery and supervision of junior engineers.",
        "Resolved issues with the AWS Events mobile application in real time during re:Invent ensuring the customer experience during the event remained uninterrupted.",
        "Significantly reduced the amount of time required for product testing by implementing full suites of automated tests.",
        "Eliminated manual reporting tasks by implementing a tool to connect automated test results to our reporting system.",
        "Enabled successful delivery of the AWS Events mobile application by quickly implementing a complicated calendar feature with which the rest of the team was struggling.",
        "Prevented rot by leading development initiatives that modernized our codebase.",
      ],
    },
    {
      company: "Mindtree LTD",
      title: "Software Engineer",
      period: "Jan 2014 – June 2016",
      bullets: [
        "Conceived, and led the creation of, a behavior-driven automated test runner using Cucumber and Angular that remains in active use.",
        "Successfully delivered a full automated testing suite for a top investment company.",
      ],
    },
  ],

  education: [
    {
      year: "2014",
      degree: "Associate of Science in Programming and Analysis",
      institution: "Santa Fe College, FL",
    },
    {
      year: "2007",
      degree: "Bachelor of Arts in Elementary Education",
      institution: "Flagler College, FL",
    },
  ],

  skills: [
    "Python",
    "Rust",
    "TypeScript",
    "Critical Code Review",
    "Mentorship",
    "Domain-Driven Design",
    "Version Control",
    "Front-End Frameworks",
    "Agile Development",
  ],
};
